export const PROPAGATE_STEP_CHANGE = 'CreateFabricInvitation/*/PropagateStepChange';
export const SET_ALL_ASSETS = 'CreateFabricInvitation/*/AllAssets';
